import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_VIEW_ROLES } from '@/features/medication-register/access'
import { EntryDetailPage } from '@/features/medication-register/entry-detail-page'

/** One ledger line in full, corrections and follow-ups included. */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/entries/$entryId/'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_VIEW_ROLES])
    await requireActiveSubscription()
  },
  component: EntryDetailPage,
})
